export default class DocumentDataStore {
  comment = "";
  internalUse = false;
  uploadedFiles: Map<string, File> = new Map();
  totalUploadedFileSize = 0;
  countFiles = 0;

  setComment(comment: string) {
    this.comment = comment;
  }

  getComment(): string {
    return this.comment;
  }

  setInternalUse(internalUse: boolean) {
    this.internalUse = internalUse;
  }

  getInternalUse(): boolean {
    return this.internalUse;
  }

  setUploadedFiles(uploadedFiles: Map<string, File>) {
    this.uploadedFiles = uploadedFiles;
    this.updateTotalUploadedFileSize();
  }

  getUploadedFiles(): Map<string, File> {
    return this.uploadedFiles;
  }

  removeFromUploadedFiles(key: string) {
    this.uploadedFiles.delete(key);
    this.updateTotalUploadedFileSize();
  }

  addToUploadedFiles(files: File[]) {
    for (const file of files) {
      this.uploadedFiles.set(this.getUniqueFileName(file.name), file);
    }
    this.updateTotalUploadedFileSize();
  }

  getTotalUploadedFileSize(): number {
    return this.totalUploadedFileSize;
  }

  isMinimalAttachmentContentSet() {
    return this.comment?.length > 0 || this.countFiles > 0;
  }

  private getUniqueFileName(fileName: string): string {
    if (!this.uploadedFiles.has(fileName)) {
      return fileName;
    }

    const periodIndex = fileName.lastIndexOf(".");
    const name = fileName.substring(0, periodIndex);
    const extension = "." + fileName.substring(periodIndex + 1);

    // add an increasing number while file name exists
    let counter = 1;
    let newFileName = name + "_(" + counter + ")" + extension;
    while (this.uploadedFiles.has(newFileName)) {
      newFileName = name + "_(" + counter + ")" + extension;
      counter++;
    }

    return newFileName;
  }

  private updateTotalUploadedFileSize() {
    let totalSize = 0;
    for (const file of this.uploadedFiles.values()) {
      totalSize += file.size;
    }
    this.totalUploadedFileSize = totalSize;
    // Maps arent reactive. With "this.countFiles" there's a reactive variable,
    // based on "this.uploadedFiles"
    this.countFiles = this.uploadedFiles.size;
  }
}
